import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './button.scss';

const Button = ({
  name,
  className,
  isDisabled,
  onClick,
  children,
  title
}) => (
  <button
    title={title}
    aria-label={title}
    type="button"
    name={name}
    className={classNames(css.button, className)}
    disabled={isDisabled}
    onClick={onClick}
  >
    {children}
  </button>
);

Button.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node
};

export default Button;
